/**
 * The paper theme shared by the artifact sheets and their PDFs: two font
 * families, four sizes, and the light end of the app's zinc palette plus one
 * accent for missing values. The sheet is always light and ignores the app
 * theme, so these are literals rather than CSS variables.
 */
export const SHEET_FONTS = {
  sans: 'Helvetica, Arial, sans-serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
} as const

export const SHEET_COLORS = {
  paper: '#ffffff',
  ink: '#18181b',
  muted: '#71717a',
  rule: '#e4e4e7',
  backdrop: '#f4f4f5',
  accent: '#b91c1c',
} as const

/** Point sizes: title, section heading, body, and small (labels, table headers, footer, captions). */
export const SHEET_SIZES = {
  title: 18,
  heading: 11,
  body: 9.5,
  small: 8,
} as const
